import { render, staticRenderFns } from "./discount.vue?vue&type=template&id=62498f96&scoped=true&"
import script from "./discount.vue?vue&type=script&lang=js&"
export * from "./discount.vue?vue&type=script&lang=js&"
import style0 from "./discount.vue?vue&type=style&index=0&id=62498f96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62498f96",
  null
  
)

export default component.exports